import React, { useRef } from "react";
import AccessibleDialog from "../UI/Modals/AccessibleDialog/AccessibleDialog";
import styles from "./ConsultOrderPromptModal.module.scss";

// ITAM-2583: the confirmation step shown before opening the order form. It holds
// no draft yet, so Escape/overlay/close all simply decline (onClose) — nothing
// is discarded. Confirming hands off to the lifecycle which hydrates the draft.

export interface ConsultOrderPromptModalProps {
  isOpen: boolean;
  callerName: string;
  onConfirm: () => void;
  onClose: () => void;
}

const TITLE_ID = "consult-order-prompt-title";

const ConsultOrderPromptModal: React.FC<ConsultOrderPromptModalProps> = ({
  isOpen,
  callerName,
  onConfirm,
  onClose,
}) => {
  const confirmRef = useRef<HTMLButtonElement>(null);

  return (
    <AccessibleDialog
      isOpen={isOpen}
      onRequestClose={onClose}
      titleId={TITLE_ID}
      initialFocusRef={confirmRef}
      maxWidth={440}
      closeButtonLabel="Zatvori"
    >
      <div className={styles.body}>
        <h2 id={TITLE_ID} className={styles.title}>
          Kreiranje porudžbine
        </h2>
        <p className={styles.message}>
          Da li želite da kreirate porudžbinu za {callerName}?
        </p>
        <div className={styles.actions}>
          <button
            type="button"
            className={styles.secondary}
            onClick={onClose}
          >
            Ne, otkaži
          </button>
          <button
            type="button"
            ref={confirmRef}
            className={styles.primary}
            onClick={onConfirm}
          >
            Da, kreiraj
          </button>
        </div>
      </div>
    </AccessibleDialog>
  );
};

export default ConsultOrderPromptModal;
